<template>
 <div class="footer-subscribe">
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper" @click.self="$emit('close')">
        <div class="modal-container">
          <div class="modal-body">
            <div class="image-details row">
              <div class="col-md-6 col-sm-12">
                 <vue-recaptcha
                    :sitekey="sitekey"
                    :loadRecaptchaScript="true"
                    @error="error"
                    @expired="expired"
                    @verify="verify"
                ></vue-recaptcha>
              </div>
              <div class="col-md-5 col-sm-12" style="text-align: right;">
                <button class="btn btn-hover pull-right btn-primary" @click="sendRequest()" style="height: 50px; width: 150px;" :disabled="(verified === true && !clicked) ? false : true"> Submit</button>
                <br>
                <span style="color: rgb(0, 92, 185); float: right; font-weight: 700; font-size: smaller;">{{ message }}</span>
              </div>
              <div class="col-md-1" style="max-width: 0px;padding: 0px;">
                <span class="modal-close" @click="$emit('close')">&times;</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</div>
</template>
<script>
import VueRecaptcha from "vue-recaptcha";

export default {
  name: "subscribe-modal",
  components: { VueRecaptcha: VueRecaptcha },
  data() {
    return {
      verified: false,
      verified_token: "",
      message : "",
      clicked : false,
    };
  },
  props: {
    sitekey: {
      type: String,
      required: true
    },
    firstname: {
      type: String,
      required: true
    },
    email: {
      type: String,
      required: true
    },
  },
  methods: {
    expired(value) {
      this.verified = false;
    },
    verify(value) {
      this.verified_token = value;
      this.verified = true;
    },
    error(value) {
      this.verified = false;
    },
    async sendRequest(){
        let data = {
          'token' : this.verified_token,
          'firstname' : this.firstname,
          'email' : this.email
        };

        let response = await axios.post(`/` + window.culture + `/subscribe-footer-api`, data);

        if (response.data.errorStatusCode && response.data.errorStatusCode == 400) {
            this.message = "Error Occurred."
        } else {
            this.message = "Request Submited."
            this.clicked = true;
            this.$emit('on-success');
        }
    }
  }
}
</script>